define(function (require) {
    "use strict";
    var $ = require('jquery'),
        _ = require('underscore'),
        Backbone = require('backbone'),
        Const = require('common/Const'),
        LoginSupport = require('components/live-agent/views/LoginSupport'),
        
        html_template = require('login/templates/Header.html'),
        template = _.template(html_template);
    return Backbone.View.extend({
        template: template,

        render: function () {
            var data = this._prepareData();
            
            this.$el.html(this.template(data));

            return this;
        },
        
        _prepareData: function() {
            var data = {
                i18n: i18n,
                i18nPage: i18n.login,
                loginUrl: oeApp.getData('common').loginUrl
            };
            
            return data;
        },
        
        onLoginSupportRender: function(){
        	this.trigger("Header::loginSupportRender");
        },

        /**
         * Display the return to login element in the header
         */
        showReturnToLogin: function () {
            var loginReturnLinkEl = $('#login2-return');
            loginReturnLinkEl.show();
        },

        /**
         * Hide the welcome back message
         */
        hideWelcomeBackMessage: function () {
            var welcomeBackEl = $('h2.welcome-message');
            welcomeBackEl.hide();
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/login/views/Header.js
// module id = 175
// module chunks = 26